import { useCallback, useRef, useState, useEffect } from "react"
import { toast } from "../CommonComponents/ToastComponent/toast"
import { useDispatch, useStore } from "react-redux"
import { EditorState } from "draft-js"
import { updatePassword, updateUser, uploadFileToS3Bucket } from "../../redux/actions/auth"
import { downloadFileFromS3Bucket } from "../../redux/actions/vendor"
import ModalComponent from "../CommonComponents/Modal"

const Title = ({ title }) => {
    return <h3 className="fw-bold text-dark">{title}</h3>
}

const General = () => {
    const dispatch = useDispatch()
    const store = useStore().getState()
    const {
        auth: { user },
    } = store

    const [userName, setuserName] = useState({ firstName: user?.firstname, lastName: user?.lastname })
    const [prevUserName, setPrevUserName] = useState({ firstName: user?.firstname, lastName: user?.lastname })
    const [password, setPassword] = useState({ new: '', confirm: '' })
    const [confirmPass, setConfirmPass] = useState(false)
    const [confirm, setConfirm] = useState(false)
    const [fileName, setFileName] = useState(null);
    const [imagePreview, setImagePreview] = useState(null);
    const [confirmDelete, setConfirmDelete] = useState(false)

    const fileInputRef = useRef(null);

    const handleTextClick = () => {
        fileInputRef.current.click();
    };

    const handleFileChange = async (event) => {
        const file = event.target.files[0];
        if (file) {
            setFileName(file.name)
            const imageUrl = URL.createObjectURL(file);
            setImagePreview(imageUrl);
            await dispatch(uploadFileToS3Bucket(file, user?.id)).then((res) => {
                downloadImage(res[1][0]?.s3FileURL)
                toast.show({
                    title: 'Success',
                    description: 'Successfully uploaded profile pic',
                })
            }).catch((err) => {
                toast.show({
                    title: 'Warning',
                    description: 'Unable to uploaded profile pic',
                })
                return
            })
        }
    };

    const onUpdate = async () => {
        if (prevUserName?.firstName === userName?.firstName && prevUserName?.lastName === userName?.lastName) {
            toast.show({
                title: 'Warning',
                description: 'This User Name Is Already Saved',
            })
            setConfirm(false)
            return
        }
        await dispatch(updateUser(userName, user?.id)).then((res) => {
            toast.show({
                title: 'Success',
                description: 'Successfully updated user',
            })
        }).catch((err) => {
            toast.show({
                title: 'Warning',
                description: 'Unable to update user',
            })
            return
        })
        setConfirm(false)
    }

    const savePasswordHandler = async () => {
        if (password?.new !== password?.confirm) {
            toast.show({
                title: 'Warning',
                description: 'Password not matched ',
            })
            setConfirmPass(false)
            return
        }

        await dispatch(updatePassword(password?.new, user?.id)).then((res) => {
            toast.show({
                title: 'Success',
                description: 'Successfully updated user',
            })
        }).catch((err) => {
            toast.show({
                title: 'Warning',
                description: 'Unable to update user',
            })
            return
        })
        setConfirmPass(false)
    }

    const downloadImage = useCallback(async (s3FileURL) => {
        await dispatch(downloadFileFromS3Bucket(s3FileURL)).then((res) => {
            const url = URL.createObjectURL(res);
            setImagePreview(url)
        }).catch((err) => {
            toast.show({
                title: 'Warning',
                description: 'Unable To Download Profile Pic',
            })
        })
    }, [])

    useEffect(() => {
        if (user?.s3FileURL) {
            downloadImage(user?.s3FileURL)
        }
    }, [user?.s3FileURL])


    return (
        <div className="border mt-4 p-5 d-flex column-gap-5 justify-content-between" >
            <div className="col-5">
                <Title title='Change name' />
                <div className="d-flex w-100  column-gap-4 mt-4">
                    <div className="d-flex flex-column w-100 row-gap-2">
                        <label style={{ fontSize: 15 }}>First name</label>
                        <input className="form-control form-control-lg w-100 border-dark" style={{ height: 45 }} value={userName?.firstName} onChange={(e) => { setuserName((prevState) => { return { ...prevState, firstName: e.target.value } }) }} />
                    </div>
                    <div className="d-flex flex-column w-100 row-gap-2" >
                        <label style={{ fontSize: 15 }}>Last name</label>
                        <input className="form-control form-control-lg w-100 border-dark" style={{ height: 45 }} value={userName?.lastName} onChange={(e) => { setuserName((prevState) => { return { ...prevState, lastName: e.target.value } }) }} />
                    </div>
                </div>
                <div className="d-flex justify-content-end mt-4 column-gap-3">
                    <button className="report_button_secondary">Cancel</button>
                    <button className="report_button_success" onClick={() => { setConfirm(true) }}>Confirm</button>
                </div>
                <hr className="mt-5 mb-5" />
                <Title title='Profile Picture' />
                <div className="border border-dark rounded mt-4 d-flex align-items-center justify-content-between p-4" style={{ height: 60 }} onClick={handleTextClick}>
                    <div className="d-flex column column-gap-3">
                        {!imagePreview && <div className="rounded-circle text-center align-middle pt-1 fs-2 text-white" style={{ height: 40, width: 40, backgroundColor: '#D9D9D9' }}>
                            A
                        </div>}
                        {imagePreview && <img src={imagePreview} className="rounded-circle" style={{ width: 30, height: 30 }} />}
                        <p className="m-0 fs-4 d-flex align-items-center text-black">{fileName ? fileName : 'Add a profile picture to personalize your account'}</p>
                    </div>
                    <input
                        type="file"
                        ref={fileInputRef}
                        style={{ display: "none" }}
                        onChange={handleFileChange}
                        accept="image/*"
                    />
                    <p className="fs-4 m-0" style={{ color: "#65B3E9", cursor: "pointer" }}>Add</p>
                </div>
            </div>
            <div className="col-5">
                <Title title='Password' />
                <div className="d-flex column-gap-4 w-100 mt-4">
                    <div className="d-flex flex-column  row-gap-2 w-100 ">
                        <label style={{ fontSize: 15 }}>New password</label>
                        <input className="form-control border-dark form-control-lg w-100" style={{ height: 45 }} value={password?.new} onChange={(e) => { setPassword((prevState) => { return { ...prevState, new: e.target.value } }) }} />
                    </div>
                    <div className="d-flex flex-column row-gap-2  w-100" >
                        <label style={{ fontSize: 15 }}>Current password</label>
                        <input className="form-control border-dark form-control-lg w-100" style={{ height: 45 }} value={password?.confirm} onChange={(e) => { setPassword((prevState) => { return { ...prevState, confirm: e.target.value } }) }} />
                    </div>
                </div>
                <p className="mt-4 fs-4">Can't remember your current password? <span className="fs-4 mt-2" style={{ color: "#65B3E9", cursor: "pointer" }}>Reset your password</span></p>
                <button className="report_button_success px-4 py-2" style={{ width: 'auto' }} onClick={() => { setConfirmPass(true) }} >Save password</button>
            </div>
        </div >
    )
}

export default General;